// Full-screen wizard layout — own shell, INTE wrapped in AppLayout (Fas 0 sektion H).
// No BottomNav, no sidebar. Mobile-first ~380px viewport (Q37). iOS safe-area
// inherited via inner WizardFooter component.

import type { ReactNode } from "react";

interface WizardLayoutProps {
  header: ReactNode;
  footer?: ReactNode;
  children: ReactNode;
}

export function WizardLayout({ header, footer, children }: WizardLayoutProps) {
  // z-[60] (above BottomNav's z-50) so the full-screen wizard covers the mobile
  // BottomNav — at z-50 == z-50 the BottomNav won on DOM-order and overlapped
  // the wizard footer CTA at mobile viewport (DEFECT #3, Chrome MCP 2026-05-27).
  return (
    <div className="fixed inset-0 z-[60] flex flex-col livfull-wizard-bg">
      {header}
      {/* pb-28: scroll-content clears the sticky footer so the last step element
          (e.g. Steg 1 visibility-toggle) is never hidden behind "Nästa" on a short
          viewport (mobile overflow). Footer is a flex sibling below; this padding
          guarantees clearance when content scrolls (FIX 2, 3b operator mobile-test). */}
      <main className="flex-1 overflow-y-auto px-4 pt-4 pb-28">{children}</main>
      {footer}
    </div>
  );
}
